import * as React from 'react';
import Modal from '@mui/material/Modal';
import PandaHeader from '../../../assets/modal/panda-header-logo.svg';
import PandaFooter from '../../../assets/modal/panda-footer-logo.svg';
import Close from '../../../assets/modal/close-x-white.svg';
import { useTranslation } from 'react-i18next';
import { EmailBirthChange } from '../components/EmailBirthChange';
import ChangeContract from '../components/ChangeContract';
import AdminPetDataChange from '../components/AdminPetDataChange';
import ReactivateContract from '../components/ReactivateContract';
import CancellationOrRevocation from '../components/CancellationOrRevocation';
import { CircularProgress } from '@mui/material';
import ThanksNotice from '../components/ThanksNotice';
import RemoveDunningsMenu from '../components/RemoveDunningsMenu';
import RemoveDunningsAll from '../components/RemoveDunningsAll';
import RemoveDunningsSelective from '../components/RemoveDunningsSelective';

const MainModal = ({
  selectedChange,
  selectedChangeTitle,
  isModalOpen,
  setSelectedChange,
  setIsOpen,
}) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = React.useState(false);
  const [isDone, setIsDone] = React.useState(false);

  function handleClose() {
    setIsOpen(false);
    setSelectedChange(null);
    setIsDone(false);
  }

  const goToRemoveAll = () => setSelectedChange('removeDunningsAll');
  const goToSelective = () => setSelectedChange('removeDunningsSelective');
  const goToMenu = () => setSelectedChange('removeDunnings');
  const closeModalCompletely = () => handleClose(); // alias for clarity

  const findComponent = () => {
    // Reactivation reports its OWN result — which instalments were allocated, or why
    // they were not. The generic notice says "Data record successfully changed!" and
    // nothing else, which is the one thing an admin cannot act on. Every other action
    // keeps it.
    if (isDone && selectedChange !== 'reactivateContract') {
      return <ThanksNotice handleClose={handleClose} />;
    }

    switch (selectedChange) {
      case 'changeBirthOrAdress':
        return (
          <EmailBirthChange
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            handleClose={handleClose}
            setIsDone={setIsDone}
          />
        );
      case 'reactivateContract':
        return (
          <ReactivateContract
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            handleClose={handleClose}
            setIsDone={setIsDone}
          />
        );
      case 'changePetData':
        return (
          <AdminPetDataChange
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setIsDone={setIsDone}
            handleClose={handleClose}
          />
        );
      case 'changeAdminContract':
        return (
          <ChangeContract
            isLoading={isLoading}
            setIsDone={setIsDone}
            setIsLoading={setIsLoading}
            handleClose={handleClose}
          />
        );
      case 'CancellationOrRevocation':
        return (
          <CancellationOrRevocation
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setIsDone={setIsDone}
            handleClose={handleClose}
          />
        );

      case 'removeDunnings':
        return (
          <RemoveDunningsMenu
            goToAll={goToRemoveAll}
            goToSelective={goToSelective}
            handleClose={handleClose}
          />
        );

      case 'removeDunningsAll':
        return (
          <RemoveDunningsAll
            onBack={goToMenu}
            onCloseModal={closeModalCompletely}
          />
        );

      case 'removeDunningsSelective':
        return (
          <RemoveDunningsSelective
            onBack={goToMenu}
            onCloseModal={closeModalCompletely}
          />
        );

      default:
        return <div></div>;
    }
  };

  return (
    <Modal
      open={isModalOpen}
      onClose={handleClose}
      className="custom_blured_background"
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="modal_container">
        <div className="modal_container__main">
          <div className="modal_container__header gap-4">
            <img
              className="modal_container__header__close"
              src={Close}
              onClick={handleClose}
            />
            <img
              className="modal_container__header__logo"
              style={{ margin: '10px 0 0 0' }}
              src={PandaHeader}
            />
            <div className="text-centered">
              <h3>{t(selectedChangeTitle)}</h3>
            </div>
          </div>

          <div className="modal_container__body">
            {findComponent()}
            {isLoading && (
              <div className="loading_container">
                <CircularProgress color="error" />
              </div>
            )}
          </div>

          <img className="modal_container__footer" src={PandaFooter} />
        </div>
      </div>
    </Modal>
  );
};

export default MainModal;
